export class BarType 
{
public static readonly SECOND_BAR    =  1;
public static readonly MINUTE_BAR    =  2;
public static readonly DAILY_BAR     =  3;
public static readonly WEEKLY_BAR    =  4;
}

/*   -------------------------------------------------------------------   */

export class ClearBits 
  {
    public static readonly BID          =  1;
    public static readonly ASK          =  2;
    public static readonly LEAN_PRICE   =  4;
  }

/*   -------------------------------------------------------------------   */  

export class Request 
{
public static readonly SUBSCRIBE   = 1;
public static readonly UNSUBSCRIBE = 2;
}

/*   -------------------------------------------------------------------   */

export class MBOUpdateType 
{
public static readonly NEW     = 1;
public static readonly CHANGE  = 2;
public static readonly DELETE  = 3;
}

/*   -------------------------------------------------------------------   */

export class UpdateType 
{
  public static readonly CLEAR_ORDER_BOOK   = 1;
  public static readonly NO_BOOK            = 2;
  public static readonly SNAPSHOT_IMAGE     = 3;
  public static readonly BEGIN              = 4;
  public static readonly MIDDLE             = 5;
  public static readonly END                = 6;
  public static readonly SOLO               = 7;
}

/*   -------------------------------------------------------------------   */

export class MktUpdateBits 
{
public static readonly LAST_TRADE              =       1;
public static readonly BBO                     =       2;
public static readonly ORDER_BOOK              =       4;
public static readonly OPEN                    =       8;
public static readonly OPENING_INDICATOR       =      16;
public static readonly HIGH_LOW                =      32;
public static readonly HIGH_BID_LOW_ASK        =      64;
public static readonly CLOSE                   =     128;
public static readonly CLOSING_INDICATOR       =     256;
public static readonly SETTLEMENT              =     512;
public static readonly MARKET_MODE             =    1024;
public static readonly OPEN_INTEREST           =    2048;
public static readonly MARGIN_RATE             =    4096;
public static readonly HIGH_PRICE_LIMIT        =    8192;
public static readonly LOW_PRICE_LIMIT         =   16384;
public static readonly PROJECTED_SETTLEMENT    =   32768;
public static readonly ADJUSTED_CLOSE          =   65536;

}

/*   -------------------------------------------------------------------   */

export class Direction 
{
public static readonly FIRST   = 1;
public static readonly LAST    = 2;
}

/*   -------------------------------------------------------------------   */

export class TimeOrder
{
public static readonly FORWARDS   = 1;
public static readonly BACKWARDS  = 2;
}

/*   -------------------------------------------------------------------   */

export class TransactionType 
{
  public static readonly BUY  = 1;
  public static readonly SELL = 2;

  static GetDisplay(iApi : number)
  {
  switch(iApi)
    {
    case TransactionType.BUY:
      return("Buy");
    case TransactionType.SELL:
      return("Sell");
    default:
      return(iApi.toString());
    }
  }
}

/*   ====================================================================   */ 

export class OrderPlacement 
{
    public static readonly MANUAL  = 1;
    public static readonly AUTO    = 2;
}

/*   ====================================================================   */

export class Duration 
{
    public static readonly DAY  = 1;
    public static readonly GTC  = 2;
    public static readonly IOC  = 3;
    public static readonly FOK  = 4;
}

/*   ====================================================================   */

export class PriceType 
{
    public static readonly LIMIT              =  1;
    public static readonly MARKET             =  2;
    public static readonly STOP_LIMIT         =  3;
    public static readonly STOP_MARKET        =  4;
    public static readonly MARKET_IF_TOUCHED  =  5;
    public static readonly LIMIT_IF_TOUCHED   =  6;

    static GetDisplay(iApi : number)
    {
    switch(iApi)
      {
      case PriceType.LIMIT:
        return("Limit");
      case PriceType.MARKET:
        return("Market");
      case PriceType.STOP_LIMIT:
        return("Stop Limit");
      case PriceType.STOP_MARKET:
        return("Stop Market");
      case PriceType.MARKET_IF_TOUCHED:
        return("Market If Touched");
      case PriceType.LIMIT_IF_TOUCHED:
        return("Limit If Touched");  
      default:
        return(iApi.toString());
      }  
    }
 }

/*   ====================================================================   */

export class CompletionReason 
{
    static GetDisplay(sApi : string)
    {
    switch(sApi)
      {
      case "fill":
        case "F":
          return("filled");
    
      case "cancel": 
      case "C":
        return("canceled");

      case "reject":
      case "R":
        return("rejected");

      case "FA":
      case "F":
        return("failure");

      default:
        return(sApi);
      }  
    }
 }

/*   ====================================================================   */

export class UserType 
{
  public static readonly USER_TYPE_FCM    = 1;
  public static readonly USER_TYPE_IB     = 2;
  public static readonly USER_TYPE_TRADER = 3;
}

/*   ====================================================================   */

export class NotifyType 
{
  public static readonly ORDER_RCVD_FROM_CLNT      =   1
  public static readonly MODIFY_RCVD_FROM_CLNT     =   2
  public static readonly CANCEL_RCVD_FROM_CLNT     =   3
  public static readonly OPEN_PENDING              =   4
  public static readonly MODIFY_PENDING            =   5
  public static readonly CANCEL_PENDING            =   6
  public static readonly ORDER_RCVD_BY_EXCH_GTWY   =   7
  public static readonly MODIFY_RCVD_BY_EXCH_GTWY  =   8
  public static readonly CANCEL_RCVD_BY_EXCH_GTWY  =   9
  public static readonly ORDER_SENT_TO_EXCH        =  10
  public static readonly MODIFY_SENT_TO_EXCH       =  11
  public static readonly CANCEL_SENT_TO_EXCH       =  12
  public static readonly OPEN                      =  13
  public static readonly MODIFIED                  =  14
  public static readonly COMPLETE                  =  15
  public static readonly MODIFICATION_FAILED       =  16
  public static readonly CANCELLATION_FAILED       =  17
  public static readonly TRIGGER_PENDING           =  18
  public static readonly GENERIC                   =  19;
  public static readonly LINK_ORDERS_FAILED        =  20;
}

/*   ====================================================================   */

export class BracketType 
{
  public static readonly STOP_ONLY               = 1;
  public static readonly TARGET_ONLY             = 2;
  public static readonly TARGET_AND_STOP         = 3;
  public static readonly STOP_ONLY_STATIC        = 4;
  public static readonly TARGET_ONLY_STATIC      = 5;
  public static readonly TARGET_AND_STOP_STATIC  = 6;
}

/*   ====================================================================   */

